import React from 'react';
import { StaticQuery, graphql, Link } from "gatsby"
import Img from "gatsby-image"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileAlt } from "@fortawesome/free-regular-svg-icons"
import './styles.scss'

const CompanyHistory = (props) => {
  return (
    <StaticQuery
      query={graphql`
        query {
          allDataYaml {
            edges {
              node {
                top {
                  history {
                    heading
                    events {
                      year
                      month
                      event
                      newsLink
                      image
                      description
                    }
                  }
                }
                language
              }
            }
          }
          historyEventsImages: allFile(filter: {relativePath: {glob: "top/history/pc/*"}}) {
            nodes {
              name
              childImageSharp {
                fluid(maxWidth: 910) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
          historyEventsSpImages: allFile(filter: {relativePath: {glob: "top/history/sp/*"}}) {
            nodes {
              name
              childImageSharp {
                fluid(maxWidth: 343) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
      `}
      render={({ allDataYaml: { edges }, historyEventsImages, historyEventsSpImages}) => {
        const { language } = props
        const { node: { top: { history } } } = edges.find(({node}) => node.language === language)
        const { heading, events } = history

        const structuredHistory = events.reduce((acc, event) => {
          const y = acc[event.year] || []
          y.push(event)
          acc[event.year] = y
          return acc
        }, {})

        const historyEventsImageMap = historyEventsImages.nodes.reduce((acc, elem) => {
          acc[elem.name] = elem
          return acc
        }, {})
        const historyEventsSpImageMap = historyEventsSpImages.nodes.reduce((acc, elem) => {
          acc[elem.name] = elem
          return acc
        }, {})

        return <div className="top-company-history">
          <h2 className="text-center">{heading}</h2>
          <ul className="company-history-diagram">
            {
              Object.keys(structuredHistory).map((key) => {
                const events = structuredHistory[key]
                return <li key={key} className="company-history-year">
                  <div className="d-xl-flex">
                    <div className="history-year-label">{key}</div>
                    <ul className="w-100">
                      {
                        events.map((event, idx) => {
                          return <li className="history-event-record" key={idx}>
                            <div className="d-flex align-items-top w-100">
                              <div className="history-month">{event.month}</div>
                              <div className="history-event-title">{event.event} { !!event.newsLink && <Link to={event.newsLink}><FontAwesomeIcon icon={faFileAlt} className="history-news-link" /></Link> }</div>
                            </div>
                            {
                              !!event.image && <div className="history-event-detail">
                                <div className="history-event-image">
                                  <div className="d-none d-xl-block"><Img fluid={historyEventsImageMap[event.image].childImageSharp.fluid} /></div>
                                  <div className="d-block d-xl-none"><Img fluid={historyEventsSpImageMap[event.image].childImageSharp.fluid} /></div>
                                </div>
                                <div className="history-event-description">{event.description}</div>
                              </div>
                            }
                          </li>
                        })
                      }
                    </ul>
                  </div>
                </li>
              })
            }
          </ul>
        </div>
      }}
    />
  )
}

export default CompanyHistory;
